<template>
	<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.9998 12C14.9998 13.6569 13.6566 15 11.9998 15C10.3429 15 8.99976 13.6569 8.99976 12C8.99976 10.3431 10.3429 9 11.9998 9C13.6566 9 14.9998 10.3431 14.9998 12Z"
			:stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		<path
			d="M2.45801 12C3.73228 7.94288 7.52257 5 12.0002 5C16.4778 5 20.2681 7.94291 21.5424 12C20.2681 16.0571 16.4778 19 12.0002 19C7.52256 19 3.73226 16.0571 2.45801 12Z"
			:stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
	</svg>

</template>

<script>
import { extractValueAndUnit } from '../../utils/iconUtils'

export default {

	name: 'IconEyeOpen',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1rem', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '1rem', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
		}
	},

	computed: {
		color() {
			return this.color_prop || getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
		},

		width() {
			const { value, unit } = extractValueAndUnit(this.width_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},

		height() {
			const { value, unit } = extractValueAndUnit(this.height_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},
	},
}
</script>

<style lang="css" scoped></style>